var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { size } from 'polished';
import { display, alignItems, position, top, space, backgroundColor, boxShadow, width, border, maxHeight, flex, } from 'styled-system';
import { themeHeight, themeWidth } from '../../common/theme/system-utilities';
import { textWithEllipsis } from '../../common/theme/helper';
import { DRAWER_WIDTH } from '../../common/components/Drawer';
import { Text } from '../../common/components/Text';
import Icon from '../../common/components/Icon';
import { useLocalization } from '../../common/providers/LocaleProvider';
var ICON_SIZE = 24;
var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 2;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 2;\n"])), display, alignItems, position, top, space, themeHeight, themeWidth, width, backgroundColor, boxShadow, border);
Button.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    width: 1,
    py: 'sp_0',
    px: 'sp_20',
    backgroundColor: 'white',
    boxShadow: 'bottom',
    border: 'none',
    themeHeight: ['54px', 'sp_64'],
    themeWidth: DRAWER_WIDTH,
};
var CloseIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), size(ICON_SIZE + "px"), space);
CloseIcon.defaultProps = {
    name: 'close',
    mr: 'sp_4',
};
var Title = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", "\n"])), maxHeight, flex, textWithEllipsis());
Title.defaultProps = {
    // fake ellipsis on 2nd line for IE11
    maxHeight: ['36px', null, null, '40px'],
    fontSize: ['fs_16', null, null, 'fs_18'],
    lineHeight: ['18px', null, null, 'lh_20'],
    textAlign: 'center',
    mr: 'sp_32',
    flex: 1,
    as: 'span',
};
var Header = function (_a) {
    var onClick = _a.onClick, title = _a.title;
    var t = useLocalization().t;
    var text = title === undefined ? t('h24_important_info') : title;
    return (React.createElement(Button, { onClick: onClick },
        React.createElement(CloseIcon, null),
        React.createElement(Title, null, text)));
};
export default Header;
var templateObject_1, templateObject_2, templateObject_3;
